import { IconPointFilled as GenericAuthorIcon } from '@tabler/icons-react';
import { useSuspenseQuery } from '@tanstack/react-query';
import { Outlet, createFileRoute } from '@tanstack/react-router';

import { getLaboratoriesOptionsForCenter } from '@/module/Laboratory';
import { getResearchCenterOptions } from '@/module/ResearchCenter';

import { ContextSidebar } from '@/core/components/RootLayout/Sidebar/ContextSidebar';

export const Route = createFileRoute('/_auth/research-center/_research-center/$researchCenterId/_layout')({
  loader: async ({ params: { researchCenterId }, context: { queryClient } }) => {
    const researchCenter = await queryClient.ensureQueryData(getResearchCenterOptions(researchCenterId));

    return {
      researchCenter,
      crumb: researchCenter.name,
    };
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { researchCenterId } = Route.useParams();
  const { data: labs } = useSuspenseQuery(getLaboratoriesOptionsForCenter(researchCenterId));

  const labTabs = labs.map(lab => ({
    label: lab.name,
    to: `/research-center/${researchCenterId}/lab/${lab.id}`,
    icon: GenericAuthorIcon,
  }));

  return (
    <>
      <ContextSidebar
        baseUrl=""
        items={labTabs}
      />
      <Outlet />
    </>
  );
}
